import React, { Dispatch } from 'react'
import EventList from './EventList'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { usePageTitle } from '../../hooks'
import * as routes from '../../routes'
import { EventModal } from './EventDetailModal'
import { FilterForm } from './EventFilter'
import { useNavigate, useParams } from 'react-router-dom'
import StageNavigation from '../shared/StageNavigation'
import { addToast } from '../../store/misc/misc'
import { ToastType } from '../../store/misc/interfaces'
import { getFilteredEvents } from '../../store/events/selectors'
import { IRegistration } from '../../store/registrations/interfaces'
import NavBadges from "../shared/NavBadges";
import { isTabletOrSmallDesktopQuery } from '../../utils'
import {useMediaQuery} from "react-responsive";
import { resetAll } from '../../store/actions'

type EventStageParams = {
    eventId: string
}

const EventStage = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { eventId } = useParams<EventStageParams>()

    const filteredEvents = useSelector(getFilteredEvents)
    const { list: regs } = useSelector((state: RootState) => state.registrations)
    const { data: program } = useSelector((state: RootState) => state.program)
    const isTabletOrSmallDesktop = useMediaQuery(isTabletOrSmallDesktopQuery)

    usePageTitle('Veranstaltungsübersicht')

    const hasRegistration = regs.some((reg: IRegistration) => (!!reg.event?.event_id))

    return (
        <>
            <h2 aria-level={1} className={"d-none d-md-block"}>
                Veranstaltungen auswählen
            </h2>
            {!isTabletOrSmallDesktop && (
                <NavBadges
                    program={program}
                    isTabletOrSmallDesktop={isTabletOrSmallDesktop}
                />
            )}
          <FilterForm />
            <EventList />
            {eventId && (
                <EventModal
                    eventId={parseInt(eventId)}
                    events={filteredEvents}
                    editable={true}
                />
            )}
            <StageNavigation
                backward={{
                    text: 'Neustart',
                    handler: () => {
                        resetRegistration(dispatch)
                    },
                }}
                forward={{
                    text: routes.REGISTRATIONS.longName,
                    handler: () => {
                        if (regs.length === 0) {
                            dispatch(
                                addToast({
                                    type: ToastType.Danger,
                                    title: 'Fehler',
                                    body: 'Bitte wählen Sie mindestens eine Veranstaltung aus.',
                                }),
                            )
                        } else {
                            navigate(routes.REGISTRATIONS.path)
                        }
                    },
                }}
                hasRegistration={hasRegistration}
            />
        </>
    )
}

const resetRegistration = (dispatch: Dispatch<any>) => {
    dispatch(resetAll())
    window.location.reload()
}

export default EventStage
